import React from 'react';

import { useSelector } from 'react-redux';

import Tag from './tag';
import { filterCustomFieldFilters } from './helpers';

import type { CustomFieldSchema } from 'bundles/crm/types';
import type { Filters } from './types';

export default function CompsCustomFieldFilterTags() {
  const currentTab: string = useSelector((state: any) => state.ui.currentTab);
  const schemas: CustomFieldSchema[] = useSelector((state: any) => state.customFieldSchemas);
  const filters: Filters = useSelector((state: any) => state.query.customFieldFilters) || {};

  const tags: React.ReactElement[] = [];

  for (const slug in filterCustomFieldFilters(schemas, filters, currentTab)) {
    const filter = filters[slug];
    const schema = schemas.find(schema => schema.slug === slug);
    if (schema) {
      tags.push(<Tag filter={filter} key={slug} schema={schema} />);
    }
  }

  return <>{tags}</>;
}
